/*
  Chrome Vector — real 3D logo + chrome melt transition.

  The logo outline was traced from chrome-vector-logo.png into closed polygons
  (outer contours + counters/holes). Those get extruded into genuine geometry
  and shaded as polished chrome, so it reflects, floats and melts for real
  rather than being a stack of flat PNGs.

  Exposes window.CVLogo3D:
    .supported            -> boolean
    .boot(canvas)         -> Promise, resolves with a controller
    controller.melt(opts) -> runs the chrome melt; opts.onCovered / opts.onDone
    controller.dispose()
*/
window.CVLogo3D = (function () {
  'use strict';

  var THREE_URL = 'https://cdn.jsdelivr.net/npm/three@0.161.0/build/three.module.js';
  var THREE_URL_ALT = 'https://unpkg.com/three@0.161.0/build/three.module.js';
  var GRID = 2048;
  var SHAPES = /*SHAPES*/[{"o":[797,1976,722,1953,637,1918,535,1863,460,1812,360,1727,320,1683,246,1588,202,1517,164,1445,121,1339,94,1240,70,1112,58,1092,42,1049,46,997,67,955,77,866,99,758,118,702,126,700,138,711,148,702,162,659,159,650,143,641,144,625,179,549,241,444,267,426,326,360,429,259,434,240,442,231,574,143,618,108,855,44,889,50,998,39,1116,40,1208,51,1237,42,1311,46,1333,63,1395,88,1411,109,1531,169,1637,240,1726,317,1818,421,1846,435,1900,522,1950,631,1949,643,1930,642,1927,648,1949,721,1957,731,1977,729,1984,735,1979,759,1995,819,2014,851,2026,951,2025,1077,2014,1170,1993,1272,1968,1353,1928,1451,1923,1488,1891,1520,1794,1660,1732,1730,1662,1792,1590,1845,1458,1923,1443,1939,1431,1961,1400,1978,1358,1983,1341,1970,1331,1969,1216,1995,1092,2010,1000,2010,931,2003],"h":[[1067,1969,1083,1959,1105,1967,1130,1967,1264,1943,1278,1938,1295,1922,1428,1866,1454,1861,1542,1810,1565,1806,1585,1794,1614,1763,1630,1756,1638,1743,1653,1737,1661,1723,1689,1710,1704,1683,1725,1671,1740,1640,1830,1514,1854,1456,1886,1407,1918,1326,1942,1246,1958,1170,1972,1049,1973,981,1965,893,1949,804,1911,673,1846,528,1753,396,1656,304,1586,248,1514,201,1415,150,1332,119,1271,116,1250,98,1226,90,1135,76,1024,72,907,83,824,99,721,132,619,180,525,238,455,290,387,351,298,447,230,558,185,658,153,756,125,901,124,938,136,957,133,983,142,1029,140,1050,126,1074,125,1097,137,1193,138,1253,164,1325,183,1350,243,1479,289,1554,295,1579,306,1597,344,1643,359,1653,370,1675,412,1717,450,1733,508,1780,595,1835,679,1878,699,1894,728,1901,749,1917,824,1941,893,1956,981,1968,1020,1958,1036,1969]]},{"o":[1188,1901,1168,1897,1151,1888,1110,1831,1089,1812,1073,1781,1049,1709,1035,1645,1017,1483,1018,1415,1028,1318,1057,1203,1125,1107,1152,1090,1179,1084,1201,1087,1225,1098,1267,1130,1283,1153,1289,1178,1300,1196,1301,1223,1333,1313,1350,1451,1350,1575,1342,1645,1332,1701,1313,1766,1289,1819,1259,1861,1226,1889],"h":[[1193,1759,1210,1751,1224,1733,1244,1648,1256,1556,1256,1464,1245,1362,1228,1295,1208,1253,1196,1241,1183,1238,1169,1243,1154,1259,1132,1315,1115,1434,1115,1514,1127,1622,1155,1727]]},{"o":[934,1892,875,1893,800,1872,793,1863,778,1809,763,1776,735,1563,720,1343,721,1256,735,1079,741,1058,757,1046,831,1053,846,1060,853,1070,825,1214,818,1309,820,1346,812,1374,819,1393,839,1401,850,1400,856,1394,860,1369,880,1306,923,1081,936,1073,976,1074,1037,1087,1045,1095,980,1359,960,1409,926,1460,922,1474,926,1496,967,1535,1003,1609,1028,1716,1028,1781,1015,1826,997,1856,970,1879],"h":[[900,1768,918,1753,925,1706,921,1657,911,1614,889,1573,868,1555,855,1535,834,1529,825,1541,836,1663,848,1722,870,1765,883,1769]]},{"o":[1487,1036,1464,1034,1444,1024,1426,1002,1400,982,1374,939,1343,859,1292,655,1280,536,1288,533,1296,551,1318,556,1329,550,1334,533,1330,520,1320,512,1304,510,1285,518,1278,512,1274,461,1278,388,1294,302,1341,218,1349,212,1392,215,1423,231,1495,320,1546,460,1584,627,1595,729,1596,792,1582,905,1568,950,1548,991,1520,1020],"h":[[1541,597,1541,584,1529,567,1516,562,1504,567,1509,591,1531,598],[1474,894,1491,882,1500,858,1505,684,1497,589,1471,491,1445,419,1423,382,1403,374,1390,380,1380,395,1367,452,1367,563,1382,676,1381,717,1408,812,1428,837,1449,884,1461,892]]},{"o":[1364,1840,1357,1833,1355,1819,1368,1708,1375,1584,1372,1429,1353,1281,1311,1102,1322,1095,1407,1091,1418,1100,1445,1316,1439,1370,1442,1380,1449,1384,1457,1377,1463,1355,1482,1161,1488,1149,1497,1152,1504,1164,1516,1233,1537,1275,1556,1344,1560,1349,1564,1346,1566,1253,1538,1098,1543,1090,1558,1083,1613,1079,1632,1100,1632,1150,1647,1181,1654,1258,1654,1364,1639,1517,1604,1685,1591,1706,1556,1734,1542,1740,1531,1735,1527,1724,1529,1662,1520,1577,1511,1573,1447,1796,1433,1811,1395,1832],"h":[]},{"o":[735,1842,726,1841,673,1810,647,1765,623,1571,608,1482,601,1473,579,1461,566,1460,554,1471,549,1490,574,1619,574,1656,598,1705,614,1762,611,1780,595,1776,542,1731,516,1657,499,1625,461,1474,431,1295,420,1128,424,1045,430,1034,450,1043,492,1038,517,1023,531,1029,518,1179,520,1283,547,1331,572,1348,590,1334,597,1278,596,1046,618,1032,645,1029,681,1036,699,1053,691,1190,691,1393,700,1534,706,1567,703,1606,720,1670,744,1823,742,1835],"h":[]},{"o":[1768,986,1660,1013,1639,1010,1627,999,1631,843,1617,661,1574,459,1522,297,1525,283,1605,341,1626,366,1644,430,1645,458,1687,580,1697,585,1701,577,1699,517,1689,442,1695,433,1712,444,1747,486,1804,575,1805,591,1778,680,1824,725,1845,753,1890,850,1892,867,1881,907,1858,938,1820,965],"h":[[1747,668,1739,655,1676,636,1648,623,1636,621,1630,626,1635,641,1713,674,1735,676],[1767,893,1784,883,1795,869,1791,810,1755,740,1738,727,1712,724,1708,736,1726,880,1742,893]]},{"o":[962,1024,909,1009,878,992,850,955,830,938,814,911,786,848,771,796,752,701,744,619,744,524,752,451,770,361,792,292,848,211,878,180,909,160,947,152,972,158,992,171,1010,194,1025,226,1049,308,1045,431,1039,442,1030,439,1007,372,978,327,954,315,937,313,917,319,899,333,882,357,867,390,850,456,842,507,838,575,841,633,836,672,843,726,856,771,881,810,887,832,910,859,930,867,951,863,972,846,998,808,1006,805,1011,812,1022,911,1011,984,988,1016],"h":[[763,634,780,636,808,624,821,607,818,590,799,584,765,590,760,604]]},{"o":[1317,1027,1220,1034,1094,1023,1072,1015,1053,987,1048,928,1051,855,1061,855,1084,878,1112,893,1128,889,1138,875,1136,729,1122,544,1129,539,1149,555,1168,556,1185,543,1196,522,1192,515,1177,510,1151,510,1125,518,1117,509,1070,179,1076,164,1098,154,1123,152,1190,161,1215,172,1225,185,1216,324,1204,386,1210,415,1212,561,1225,735,1236,828,1255,882,1261,888,1270,888,1301,869,1324,899,1339,1002,1334,1019],"h":[]},{"o":[532,964,518,951,512,911,509,616,520,492,541,390,540,345,548,303,554,292,576,276,647,238,723,206,780,190,787,196,787,207,740,357,731,360,707,341,688,335,667,341,648,357,634,379,621,414,603,511,606,526,624,559,633,566,657,565,670,556,681,539,692,542,704,599,708,690,702,697,694,699,648,677,632,675,619,678,603,700,594,756,601,794,647,858,666,862,690,858,709,848,723,827,735,829,763,896,772,943,771,970,761,981,737,983],"h":[]},{"o":[173,1020,165,1006,164,949,178,842,196,769,233,673,291,560,345,480,425,390,473,346,481,345,486,370,473,510,479,756,472,789,479,821,477,952,462,964,409,969,388,966,378,956,389,858,392,703,385,594,381,584,374,581,361,594,331,651,295,754,279,852,279,979,265,990,186,1020],"h":[[413,745,426,745,457,727,461,707,456,691,441,692,414,710,408,727],[190,887,206,884,253,838,263,821,261,808,246,807,208,838,188,867]]},{"o":[1657,1644,1651,1638,1650,1627,1675,1484,1683,1377,1682,1258,1662,1075,1678,1064,1791,1030,1884,987,1896,986,1905,999,1906,1044,1891,1126,1879,1133,1836,1121,1803,1127,1780,1145,1767,1178,1766,1230,1781,1249,1793,1252,1821,1247,1851,1221,1858,1223,1861,1232,1850,1306,1839,1318,1798,1334,1777,1352,1764,1385,1767,1420,1777,1428,1789,1423,1806,1386,1830,1359,1841,1362,1839,1380,1808,1449,1776,1503,1681,1630,1668,1642],"h":[]},{"o":[471,1678,462,1677,409,1643,325,1544,256,1429,205,1302,175,1179,172,1147,179,1109,196,1081,273,1042,286,1040,305,1050,333,1046,345,1032,360,1030,379,1035,389,1046,394,1186,392,1238,386,1241,379,1237,358,1202,339,1182,323,1173,308,1172,292,1181,281,1198,275,1222,276,1256,298,1349,342,1453,355,1462,378,1463,388,1453,403,1418,410,1417,418,1427,477,1647,478,1668],"h":[]}]/*ENDSHAPES*/;

  var api = { supported: false, boot: boot };
  /* Shared so the page-transition module can reuse the identical melt. */
  api.loadThree = loadThree;
  api.markSRGB = markSRGB;

  try {
    var probe = document.createElement('canvas');
    api.supported = !!(window.WebGLRenderingContext &&
      (probe.getContext('webgl2') || probe.getContext('webgl') || probe.getContext('experimental-webgl')));
  } catch (e) { api.supported = false; }

  /* Dynamic import kept behind new Function so browsers without it fail at
     call time (catchable) instead of failing to parse this whole file. */
  function importModule(url) {
    try {
      var dynamicImport = new Function('u', 'return import(u)');
      return dynamicImport(url);
    } catch (e) {
      return Promise.reject(e);
    }
  }

  function loadThree() {
    /* A build already on the page (UMD script tag, bundler) wins. */
    if (window.THREE && window.THREE.WebGLRenderer) return Promise.resolve(window.THREE);
    return importModule(THREE_URL)['catch'](function () {
      return importModule(THREE_URL_ALT);
    });
  }

  /* Works across three versions: sRGB moved from .encoding to .colorSpace. */
  function markSRGB(THREE, tex) {
    if (!tex) return;
    if (THREE.SRGBColorSpace) tex.colorSpace = THREE.SRGBColorSpace;
    else if (THREE.sRGBEncoding) tex.encoding = THREE.sRGBEncoding;
  }

  function boot(canvas) {
    if (!api.supported || !canvas) return Promise.reject(new Error('CVLogo3D unsupported'));
    return loadThree().then(function (THREE) { return build(THREE, canvas); });
  }

  /* ---------- geometry ---------- */

  function contourToPoints(THREE, flat) {
    var pts = [];
    for (var i = 0; i < flat.length; i += 2) {
      pts.push(new THREE.Vector2(
        (flat[i] / GRID) * 2 - 1,
        (flat[i + 1] / GRID) * 2 - 1
      ));
    }
    return pts;
  }

  function buildLogoGeometry(THREE) {
    var shapes = [];
    for (var i = 0; i < SHAPES.length; i++) {
      var s = SHAPES[i];
      var shape = new THREE.Shape(contourToPoints(THREE, s.o));
      if (s.h) {
        for (var j = 0; j < s.h.length; j++) {
          shape.holes.push(new THREE.Path(contourToPoints(THREE, s.h[j])));
        }
      }
      shapes.push(shape);
    }
    /* bevelSegments was 4. Triangulating thirteen contours with holes is a
       synchronous main-thread job, and it is what froze the page for a beat
       right as the lobby appeared. At this size the bevel is a couple of
       pixels wide, so 2 segments is indistinguishable and roughly halves both
       the build time and the vertex count. */
    var geo = new THREE.ExtrudeGeometry(shapes, {
      depth: 0.14,
      bevelEnabled: true,
      bevelThickness: 0.022,
      bevelSize: 0.013,
      bevelOffset: 0,
      bevelSegments: 2,
      curveSegments: 2
    });
    geo.center();
    geo.computeVertexNormals();
    return geo;
  }

  /* ---------- studio environment (drives the chrome reflections) ---------- */

  function buildEnvTexture(THREE) {
    /* Was 1024x512. Every source here is a soft gradient, so PMREM's blurred
       mips come out identical from half the pixels — and PMREM prefilter cost
       scales with the input, so this is straight boot time back. */
    var W = 512, H = 256, S = W / 1024;
    var c = document.createElement('canvas');
    c.width = W; c.height = H;
    var x = c.getContext('2d');
    x.scale(S, S);

    var sky = x.createLinearGradient(0, 0, 0, 512);
    sky.addColorStop(0.00, '#ffffff');
    sky.addColorStop(0.30, '#cfe6f4');
    sky.addColorStop(0.47, '#6f8ea3');
    sky.addColorStop(0.50, '#0d141c');
    sky.addColorStop(0.72, '#1b2733');
    sky.addColorStop(1.00, '#05080c');
    x.fillStyle = sky;
    x.fillRect(0, 0, 1024, 512);

    /* Softbox strips: these become the long highlights sliding over the metal. */
    function strip(cx, cy, w, h, alpha, colour) {
      var g = x.createRadialGradient(cx, cy, 0, cx, cy, Math.max(w, h));
      g.addColorStop(0, 'rgba(' + colour + ',' + alpha + ')');
      g.addColorStop(1, 'rgba(' + colour + ',0)');
      x.save();
      x.translate(cx, cy);
      x.scale(1, h / w);
      x.translate(-cx, -cy);
      x.fillStyle = g;
      x.beginPath();
      x.arc(cx, cy, w, 0, Math.PI * 2);
      x.fill();
      x.restore();
    }

    strip(210, 120, 300, 90, 1.0, '255,255,255');
    strip(760, 90, 250, 70, 0.95, '255,255,255');
    strip(500, 250, 420, 46, 0.55, '214,240,255');
    strip(120, 330, 260, 120, 0.30, '127,203,239');  /* brand baby blue */
    strip(880, 360, 240, 130, 0.22, '255,79,216');   /* brand pop pink */
    strip(430, 452, 520, 90, 0.35, '160,186,205');

    var tex = new THREE.Texture(c);
    tex.mapping = THREE.EquirectangularReflectionMapping;
    markSRGB(THREE, tex);
    tex.needsUpdate = true;
    return tex;
  }

  /* ---------- melt shader ---------- */

  /* The melt shader lives in cv-chrome-transition.js so the entrance and the
     page transitions always use the identical chrome. That script is loaded
     first in theme.liquid. */
  function meltShaders() {
    if (window.CVChrome && window.CVChrome.MELT_FRAG) {
      return { vert: window.CVChrome.MELT_VERT, frag: window.CVChrome.MELT_FRAG };
    }
    return null;
  }

  /* ---------- scene ---------- */

  function build(THREE, canvas) {
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var lowPower = !!(window.CVChrome && window.CVChrome.LOW_POWER);

    /* Ceiling on fragments, not on device ratio. A device-ratio cap means a
       laptop at 1440x900 and a phone at 390x844 do wildly different amounts of
       work for the same number, and an iPad in landscape does more than either.
       The badge scene is cheaper per pixel than the chrome curtain, so it gets
       a larger budget, derived from the same viewport measurement. */
    var HARD_DPR = lowPower ? 1.5 : 2;
    var BUDGET = lowPower ? 1150000 : 2400000;
    function maxDpr() {
      if (window.CVChrome && window.CVChrome.fitDpr) {
        return window.CVChrome.fitDpr(BUDGET, HARD_DPR);
      }
      return Math.min(window.devicePixelRatio || 1, HARD_DPR);
    }

    var renderer = new THREE.WebGLRenderer({
      canvas: canvas,
      /* MSAA allocates and resolves a buffer the size of the whole canvas every
         frame, whether or not the badge covers it — and the badge covers maybe
         a third of a phone screen. So on mobile the antialiasing was costing
         full-screen work for a third of a screen's worth of edges. Turning it
         off and leaving the backing store at 1.5x is the better trade: the
         browser's upscale to a 3x panel smooths the edges anyway. */
      antialias: !lowPower,
      alpha: true,
      premultipliedAlpha: false,
      powerPreference: 'high-performance'
    });
    renderer.setClearColor(0x000000, 0);
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.05;

    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(38, 1, 0.1, 100);
    camera.position.set(0, 0, 4.7);

    var pmrem = new THREE.PMREMGenerator(renderer);
    pmrem.compileEquirectangularShader();
    var envTex = buildEnvTexture(THREE);
    var envRT = pmrem.fromEquirectangular(envTex);
    scene.environment = envRT.texture;
    envTex.dispose();
    pmrem.dispose();

    /* Clearcoat compiles in a whole second specular lobe. On a fully metallic
       surface it mostly restates the highlight the base layer already has, so
       phones trade it for a touch more env intensity and get the same read at
       a materially cheaper fragment shader. */
    var faceMat = new THREE.MeshPhysicalMaterial({
      color: 0xffffff, metalness: 1.0, roughness: 0.055,
      envMapIntensity: lowPower ? 1.9 : 1.75,
      clearcoat: lowPower ? 0.0 : 1.0, clearcoatRoughness: 0.04
    });
    var sideMat = new THREE.MeshPhysicalMaterial({
      color: 0xf2f6f9, metalness: 1.0, roughness: 0.19,
      envMapIntensity: lowPower ? 1.62 : 1.5,
      clearcoat: lowPower ? 0.0 : 0.7, clearcoatRoughness: 0.16
    });

    var geo = buildLogoGeometry(THREE);
    /* Faces use group 0 and extruded sides group 1. If a given three build
       emits no groups, one material must be used or nothing would draw. */
    var logoMat = (geo.groups && geo.groups.length > 1) ? [faceMat, sideMat] : faceMat;
    var logo = new THREE.Mesh(geo, logoMat);

    var group = new THREE.Group();
    group.add(logo);
    scene.add(group);

    /* At metalness 1 and roughness 0.055 there is no diffuse term at all — the
       chrome look comes almost entirely from the environment map, and each
       direct light adds only a small sharp specular on top. Every one of them
       still compiles another lighting loop into the fragment shader though, so
       on mobile the rim and pop lights were most of the per-pixel cost for very
       little of the picture. The environment already carries baby blue and pink
       softboxes, so the tint survives without them. */
    var key = new THREE.DirectionalLight(0xffffff, 2.6);
    key.position.set(-2.4, 3.0, 4.0);
    scene.add(key);
    if (!lowPower) {
      var rim = new THREE.DirectionalLight(0x8fd6f5, 2.2);
      rim.position.set(3.4, -1.2, -2.6);
      scene.add(rim);
      var pop = new THREE.DirectionalLight(0xff4fd8, 0.9);
      pop.position.set(2.6, -2.6, 2.4);
      scene.add(pop);
    }
    scene.add(new THREE.AmbientLight(0x9fb4c6, lowPower ? 0.45 : 0.35));

    /* Composite pass */
    var rt = null;
    var quadScene = new THREE.Scene();
    var quadCam = new THREE.Camera();
    var shaders = meltShaders();
    if (!shaders) throw new Error('CVChrome melt shader unavailable');
    var meltMat = new THREE.ShaderMaterial({
      vertexShader: shaders.vert,
      fragmentShader: shaders.frag,
      transparent: true,
      depthTest: false,
      depthWrite: false,
      uniforms: {
        tScene: { value: null },
        uTime: { value: 0 },
        uFlood: { value: 0 },
        uDrain: { value: 0 },
        uAspect: { value: 1 }
      }
    });
    var quadGeo = new THREE.BufferGeometry();
    quadGeo.setAttribute('position', new THREE.BufferAttribute(new Float32Array([
      -1, -1, 0, 3, -1, 0, -1, 3, 0
    ]), 3));
    quadGeo.setAttribute('uv', new THREE.BufferAttribute(new Float32Array([
      0, 0, 2, 0, 0, 2
    ]), 2));
    var quadMesh = new THREE.Mesh(quadGeo, meltMat);
    /* The quad ignores camera matrices entirely, so its bounding sphere is
       meaningless — without this it gets culled and nothing is drawn. */
    quadMesh.frustumCulled = false;
    quadScene.add(quadMesh);

    /* ---------- sizing ---------- */

    var width = 1, height = 1, dpr = 1;
    /* Adaptive: drops if frames come in slow, so a weak GPU loses resolution
       instead of losing frame rate. */
    var quality = 1;

    /* The composite target is only needed once chrome is on screen. Building it
       up front meant carrying a full-screen multisampled buffer, and a resolve
       of it, through the entire standing lobby for nothing. */
    function ensureTarget() {
      var w = Math.max(1, Math.round(width * dpr));
      var h = Math.max(1, Math.round(height * dpr));
      if (rt) { rt.setSize(w, h); }
      else {
        var opts = { type: THREE.UnsignedByteType };
        /* Multisampling only exists on WebGL2 / newer three builds. */
        if (renderer.capabilities && renderer.capabilities.isWebGL2) opts.samples = lowPower ? 0 : 4;
        rt = new THREE.WebGLRenderTarget(w, h, opts);
        /* Scene is encoded to sRGB on the way into the target, so the melt
           pass can composite and output it without any further conversion. */
        markSRGB(THREE, rt.texture);
      }
      meltMat.uniforms.tScene.value = rt.texture;
      return rt;
    }

    /* Leaving the lobby is the one moment this file renders two full-screen
       passes: the badge into a target, then the chrome melt over the whole
       viewport. It is also the moment the picture is smeared and moving fastest,
       so it is where resolution is least missed. Phones drop the backing store
       for the duration and get it back when the melt is done. */
    var MELT_SCALE = lowPower ? 0.7 : 0.9;

    function resize() {
      var rect = canvas.getBoundingClientRect();
      width = Math.max(1, Math.round(rect.width));
      height = Math.max(1, Math.round(rect.height));
      dpr = Math.max(0.7, maxDpr() * quality * (melting ? MELT_SCALE : 1));
      renderer.setPixelRatio(dpr);
      renderer.setSize(width, height, false);
      camera.aspect = width / height;
      /* Keep the badge fully in frame on tall/narrow phone viewports. */
      var fit = Math.min(1, (width / height) / 0.85);
      camera.position.z = 5.35 / Math.max(0.55, fit);
      camera.position.y = 0;
      camera.lookAt(0, 0, 0);
      camera.updateProjectionMatrix();
      meltMat.uniforms.uAspect.value = width / height;
      if (rt) ensureTarget();
    }
    resize();

    /* Resize fires in bursts while a window is dragged; one layout read and one
       buffer reallocation per frame is plenty. */
    var resizePending = 0;
    function onResize() {
      if (resizePending) return;
      resizePending = requestAnimationFrame(function () { resizePending = 0; resize(); });
    }
    window.addEventListener('resize', onResize, { passive: true });

    /* ---------- pointer parallax ---------- */

    var px = 0, py = 0, tx = 0, ty = 0;
    function onPointer(e) {
      var p = e.touches ? e.touches[0] : e;
      tx = (p.clientX / window.innerWidth) * 2 - 1;
      ty = (p.clientY / window.innerHeight) * 2 - 1;
    }
    window.addEventListener('pointermove', onPointer, { passive: true });

    /* ---------- loop ---------- */

    var clock = { t0: performance.now(), t: 0 };
    var intro = 0;
    var flood = 0, drain = 0;
    var melting = false, coveredFired = false, doneFired = false;
    var meltCb = {};
    var running = true;
    var rafId = 0;

    var FLOOD_MS = 1150;
    var DRAIN_MS = 1050;
    var meltStart = 0;

    var lastFrame = 0;
    var slowFrames = 0;
    var degraded = 0;

    function frame() {
      if (!running) return;
      rafId = requestAnimationFrame(frame);

      /* A backgrounded tab still gets occasional callbacks; there is nothing to
         draw and the first frame back would otherwise take a huge delta. */
      if (document.hidden) { lastFrame = 0; return; }

      var now = performance.now();
      var t = (now - clock.t0) / 1000;
      clock.t = t;

      /* Delta-normalised to 60fps. Previously the settle and the parallax
         advanced a fixed amount per frame, so the whole thing ran at double
         speed on a 120Hz screen and crawled on a slow one — which is a lot of
         what read as "not smooth" even when frames were fine. */
      var dtms = lastFrame ? Math.min(now - lastFrame, 100) : 16.7;
      lastFrame = now;
      var k = dtms / 16.7;

      /* Sustained slow frames cost resolution rather than smoothness. The
         threshold used to be 45 frames, which on a phone struggling at 20fps is
         over two seconds of visible judder before anything happened — most of
         the time someone actually spends looking at the badge. */
      if (!melting && degraded < 3) {
        if (dtms > 22) { slowFrames++; } else { slowFrames = Math.max(0, slowFrames - 1); }
        if (slowFrames > 18) {
          slowFrames = 0;
          degraded++;
          quality = Math.max(0.55, quality - 0.18);
          resize();
        }
      }

      /* The badge is already there — this is a short settle, not an arrival. */
      intro = Math.min(1, intro + (reduced ? 0.25 : 0.028) * k);
      var e = 1 - Math.pow(1 - intro, 3);

      var ease = 1 - Math.pow(1 - 0.055, k);
      px += (tx - px) * ease;
      py += (ty - py) * ease;

      var floatY = Math.sin(t * 0.62) * 0.085;
      var floatX = Math.sin(t * 0.41 + 1.2) * 0.03;

      group.rotation.y = (1 - e) * -0.45 + Math.sin(t * 0.44) * 0.40 + px * 0.42;
      group.rotation.x = Math.sin(t * 0.33) * 0.15 + 0.05 + py * -0.24;
      group.rotation.z = Math.sin(t * 0.27) * 0.045;
      group.position.set(floatX, floatY, (1 - e) * -0.5);
      group.scale.setScalar(0.94 + 0.06 * e);

      if (melting) {
        var m = now - meltStart;
        if (reduced) { flood = 1; drain = 1; }
        else {
          flood = Math.min(1, m / FLOOD_MS);
          drain = Math.max(0, Math.min(1, (m - FLOOD_MS - 140) / DRAIN_MS));
        }
        /* Badge sinks and tips as it goes under. */
        group.position.y -= flood * 0.9;
        group.rotation.x += flood * 0.5;
        group.scale.multiplyScalar(1 - flood * 0.18);

        if (!coveredFired && flood >= 1) {
          coveredFired = true;
          if (meltCb.onCovered) meltCb.onCovered();
        }
        if (!doneFired && drain >= 1) {
          doneFired = true;
          if (meltCb.onDone) meltCb.onDone();
        }
      }

      /* Standing lobby: one pass, straight to the screen. The melt composite is
         a full-screen pass over a full-screen texture, and it was running on
         every frame of a screen where nothing was melting. Skipping it is the
         single biggest saving here — and rendering direct also means the
         renderer's own MSAA does the badge edges. */
      if (!melting) {
        renderer.setRenderTarget(null);
        renderer.clear();
        renderer.render(scene, camera);
        return;
      }

      meltMat.uniforms.uTime.value = t;
      meltMat.uniforms.uFlood.value = flood;
      meltMat.uniforms.uDrain.value = drain;

      renderer.setRenderTarget(ensureTarget());
      renderer.clear();
      renderer.render(scene, camera);

      renderer.setRenderTarget(null);
      renderer.clear();
      renderer.render(quadScene, quadCam);
    }
    rafId = requestAnimationFrame(frame);

    function dispose() {
      running = false;
      cancelAnimationFrame(rafId);
      if (resizePending) cancelAnimationFrame(resizePending);
      window.removeEventListener('resize', onResize);
      window.removeEventListener('pointermove', onPointer);
      geo.dispose(); quadGeo.dispose();
      faceMat.dispose(); sideMat.dispose(); meltMat.dispose();
      if (rt) rt.dispose();
      envRT.dispose();
      renderer.dispose();
    }

    return {
      /* Called when the visitor is about to press ENTER. Allocating the
         multisampled buffer and compiling the melt program takes a few
         milliseconds — worth spending while they are still reaching for the
         button rather than on the first frame of the animation. */
      prewarm: function () {
        try {
          /* Allocated at melt resolution so pressing ENTER does not trigger a
             reallocation on the first melted frame. */
          var was = dpr;
          dpr = Math.max(0.7, maxDpr() * quality * MELT_SCALE);
          ensureTarget();
          dpr = was;
          renderer.compile(quadScene, quadCam);
        } catch (e) {}
      },
      melt: function (opts) {
        if (melting) return;
        melting = true;
        /* Re-fit first so the target is allocated at melt resolution rather
           than being built at full size and immediately resized. */
        resize();
        ensureTarget();
        meltStart = performance.now();
        meltCb = opts || {};
      },
      meltDuration: FLOOD_MS + 140 + DRAIN_MS,
      floodDuration: FLOOD_MS,
      dispose: dispose
    };
  }

  return api;
})();
